module.exports = __webpack_public_path__ + "static/media/about.480913f8.png";